export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4848.f4fb9472.jpg";